import React, { useEffect, useState } from 'react';
import { CustomLink, SectionWrapper } from '@components/Styles/CommonStyle';
import { useLoading } from '@context/LoadingContext';
import api from '@api/axios';
import { formatAmount } from '@utils/formatter';
import { theme } from '@components/Styles/theme';
import { Stack, Typography } from '@mui/material';
import {
  CustomTableContainer,
  CustomTable,
  CustomTableRow,
  CustomHeaderCell,
  CustomBodyCell,
} from '@components/Styles/TableStyle';
import { TableHead, TableBody } from '@mui/material';
import moment from 'moment';
import SectionToggle from '@components/common/Shared/SectionToggle';

const ProjectListTableStatusV2 = ({ onSearch, getYearlyFinance, navigate, year, projectStatus }) => {
  
  const localStorageOpen = localStorage.getItem("사업 현황");
  const [open, setOpen] = useState(localStorageOpen === null ? true : localStorageOpen === "true");

  return (
    <React.Fragment>
      {
        <SectionWrapper>
          <SectionToggle title="사업 현황" open={open} setOpen={setOpen} sx={theme.typography.h4} />
          {open && (
            <CustomTableContainer>
              <CustomTable merge>
                <TableHead>
                  <CustomTableRow>
                    <CustomHeaderCell />
                    <CustomHeaderCell align="center">전체</CustomHeaderCell>
                    <CustomHeaderCell align="center">진행</CustomHeaderCell>
                    <CustomHeaderCell align="center">완료</CustomHeaderCell>
                    <CustomHeaderCell align="center">대기</CustomHeaderCell>
                    <CustomHeaderCell align="center">예정</CustomHeaderCell>
                  </CustomTableRow>
                </TableHead>

                <TableBody>
                  <CustomTableRow>
                    <CustomHeaderCell scope="row" align="center">
                      {year}
                    </CustomHeaderCell>
                    <CustomBodyCell
                      align="center"
                      onClick={() => {
                        onSearch({page: 1, manualSearch: false, status: '', init: true});
                        getYearlyFinance(false, '');
                      }}
                    >
                      <CustomLink color="red" hoverColor="red" textDecoration="underline">
                        {projectStatus?.progress + projectStatus?.completed + projectStatus?.waiting}
                      </CustomLink>
                    </CustomBodyCell>
                    <CustomBodyCell
                      align="center"
                      onClick={() => {
                        onSearch({page: 1, manualSearch: false, status: 'progress', init: false});
                        getYearlyFinance(false, 'progress');
                      }}
                    >
                      <CustomLink color="blue" hoverColor="blue" textDecoration="underline">
                        {projectStatus?.progress && projectStatus?.progress}
                      </CustomLink>
                    </CustomBodyCell>
                    <CustomBodyCell
                      align="center"
                      // style={{ color: 'blue', cursor: 'pointer' }}
                      onClick={() => {
                        onSearch({page: 1, manualSearch: false, status: 'completed', init: false});
                        getYearlyFinance(false, 'completed');
                      }}
                    >
                      <CustomLink color="blue" hoverColor="blue" textDecoration="underline">
                        {projectStatus?.completed && projectStatus?.completed}
                      </CustomLink>
                    </CustomBodyCell>
                    <CustomBodyCell
                      align="center"
                      onClick={() => {
                        onSearch({page: 1, manualSearch: false, status: 'waiting', init: false});
                        getYearlyFinance(false, 'waiting');
                      }}
                    >
                      <CustomLink color="blue" hoverColor="blue" textDecoration="underline">
                        {projectStatus?.waiting && projectStatus?.waiting}
                      </CustomLink>
                    </CustomBodyCell>

                    <CustomBodyCell align="center" onClick={() => navigate('/project/PlannedProjectList')}>
                      <CustomLink hoverColor="inherit" textDecoration="underline">
                        {projectStatus?.planned && projectStatus?.planned}
                      </CustomLink>
                    </CustomBodyCell>
                  </CustomTableRow>
                </TableBody>
              </CustomTable>
            </CustomTableContainer>
          )}
        </SectionWrapper>
      }
    </React.Fragment>
  );
};

export default ProjectListTableStatusV2;
